import React from "react";
import { ITextBlockWidget } from "apiConsumers/newsApiConsumer/models/INewsArticle";
import decodeUnderline from "../utils/decodeUnderline";

interface IProps {
    text?: ITextBlockWidget;
}

export default function TextBlock(props: IProps) {
    const { text } = props;

    if (typeof text === "undefined") return null;

    const { align, content } = text;

    if (typeof align === "undefined" || typeof content === "undefined") return null;

    return (
        <div style={{ textAlign: align }}>
            {content.map((item, i) => (
                <div
                    key={`textblock${i}`}
                    dangerouslySetInnerHTML={{ __html: decodeUnderline(item) }}
                />
            ))}
        </div>
    );
}
